/**
 *
 * @/services/helpers/groups.js
 *
 */

//
// IMPORTS
//

//

//
//
//

export const buildGroupRequestPayload = obj => {
  const form = new FormData()

  // - Identificação
  if (obj.image) form.append("image", obj.image)                                                                    // [Blob] Imagem                                    (Firebase: img)
  form.append("name", obj.name)                                                                                     // [String] Nome                                    (Firebase: nome)
  form.append("description", obj.description)                                                                       // [String] Descrição                               (Firebase: des)
  if (obj.cnpj) form.append("cnpj", obj.cnpj)                                                                       // [String] CNPJ                                    (Firebase: cnpj)

  // - Locais (Nota: fixLocais deduzido pelo Laravel)
  if (Array.isArray(obj.locations) && obj.locations.length > 0) {
    // form.append("usePresetLocations", "1")                                                                       // [Bool] Pré-definir locais                        (Firebase: fixLocais)
    obj.locations.forEach(l => { form.append("locations[]", l.name) })                                              // [Array of strings] Locais -> Nome do local       (Firebase: locais: { "id_1": { nome: "Local 1", ... }, "id_2": { nome: "Local 2", ... } })
  }

  // - Ações de plantão
  if (obj.createDuty) form.append("settings[createDuty]", "1")                                                      // [Bool] Usuários podem criar plantões             (Firebase: allowCreateDuty)
  if (obj.dropDuty) form.append("settings[dropDuty]", "1")                                                          // [Bool] Plantonista pode "largar" o plantão       (Firebase: allowPassDuty)
  if (obj.disableStart) form.append("settings[disableStart]", "1")                                                  // [Bool] Desativar "Iniciar plantão"               (Firebase: disableShiftStart)
  if (obj.disableEnd) form.append("settings[disableEnd]", "1")                                                      // [Bool] Desativar "Encerrar plantão"              (Firebase: disableShiftEnd)
  if (obj.startOnlyOnShiftDay) form.append("settings[startOnlyOnShiftDay]", "1")                                    // [Bool] Iniciar plantão apenas no dia do plantão  (Firebase: startShiftOnDayOnly)
  if (obj.pauseDuringShift) form.append("settings[pauseDuringShift]", "1")                                          // [Bool] Plantão com intervalo                     (Firebase: allowPauseDuringShift)
  if (obj.splitDuty) form.append("settings[splitDuty]", "1")                                                        // [Bool] Permitir dividir plantão                  (Firebase: allowDutySplitting)

  // - Notificações
  if (obj.remindShiftStart) form.append("settings[remindShiftStart]", "1")                                          // [Bool] Lembrar início do plantão                 (Firebase: remindShiftStart)

  // - Restrições de plantão
  if (obj.hideDutyValue) form.append("settings[hideDutyValue]", "1")                                                // [Bool] Ocultar valor do plantão                  (Firebase: hideDutyValue)
  if (obj.filterOnlyAvailableDuties) form.append("settings[filterOnlyAvailableDuties]", "1")                        // [Bool] Mostrar somente "plantões" livres         (Firebase: hideGroupShiftsTab)

  // - Plantão do tipo disponível
  if (obj.allowDutyCandidates) form.append("settings[allowDutyCandidates]", "1")                                    // [Bool] Usuários se candidatam para pegar         (Firebase: allowDutyCandidates)

  // - Passagem de plantão
  if (obj.disablePassToGroupAndUser) form.append("settings[disablePassToGroupAndUser]", "1")                        // [Bool] Desativar "Passar plantão"                (Firebase: disablePassToGroupAndUser)
  if (obj.disablePassToGroup) form.append("settings[disablePassToGroup]", "1")                                      // [Bool] Desativar "Passar para o grupo"           (Firebase: disablePassToGroup)
  if (obj.requireAcceptance) form.append("settings[requireAcceptance]", "1")                                        // [Bool] Confirmar recebimento do plantão          (Firebase: approvePassDuty)
  if (obj.requireAcceptance && obj.onlyManagersCanAccept) form.append("settings[onlyManagersCanAccept]", "1")       // [Bool] Apenas gestores autorizam o recebimento   (Firebase: whoCanAcceptOrRefuse)

  // - Conflitos sequenciais
  if (obj.sequentialDutyConflictsInterval) form.append("settings[interval]", obj.sequentialDutyConflictsInterval)   // [Integer] Intervalo em minutos                   (Firebase: sequentialShiftConflictsInterval)

  // - SOS Portal
  if (obj.requireSosPortalAppointmentKeys) form.append("settings[requireAppointmentKeys]", obj.requireSosPortalAppointmentKeys) // [Bool] Obrigar o preenchimento do "Código de regulação" e "Chave de confirmação" nos agendamentos   (Firebase: requireSosPortalAppointmentKeys)

  // - Outros
  if (obj.checkinWindow) form.append("settings[checkinWindow]", obj.checkinWindow)                                      // [Integer] Janela de check-in em minutos          (Firebase: checkinWindow)
  if (obj.checkoutWindow) form.append("settings[checkoutWindow]", obj.checkoutWindow)                                  // [Integer] Janela de check-out em minutos         (Firebase: checkoutWindow)

  return form
}
